const EcalService = {

    init() {
        this.setVars();
        this.loadEcal();
    },

    setVars() {
        window._eCal = [];
        window.eCalCdnUrl = '//button.ecal.com/';
        window.eCalapiKey = 'acdd882576f17954c226319e2c3985d65446e565643ca';
    },

    loadEcal() {
        const ecalWidgetJS = document.createElement('script');

        ecalWidgetJS.src = window.eCalCdnUrl + 'js/eCal.js?_=' + new Date().getTime();

        document.getElementsByTagName('head')[0].appendChild(ecalWidgetJS);
    }
};

export default EcalService;



// WEBPACK FOOTER //
// ./libs/eCalService/eCalService.js